import { useCallback } from 'react';

import { observer } from 'mobx-react';

import crownPillowImg from '../../../../assets/crown-dialog/crown-pillow.webp';
import { useStores } from '../../../../stores/useStores';
import type { UpcomingDailyMissionWidgetData, WidgetSizeType } from '../../types';
import { GeneralSmallWidget, GeneralWideWidget } from '../GeneralWidget';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

import { UpcomingDailyMissionWidgetTimer } from './UpcomingDailyMissionWidgetTimer/UpcomingDailyMissionWidgetTimer';

interface UpcomingDailyMissionWidgetProps {
  sizeType: WidgetSizeType;
  data: UpcomingDailyMissionWidgetData;
}

function UpcomingDailyMissionWidgetComponent(props: UpcomingDailyMissionWidgetProps) {
  const { data, sizeType } = props;
  const { event } = data;
  const { dailyMissionsStore } = useStores();

  const handleClick = useCallback(() => {
    dailyMissionsStore.setDialogVisible(true);
  }, [dailyMissionsStore]);

  const timer = <UpcomingDailyMissionWidgetTimer event={event} extended={sizeType === 'wide'} />;

  return (
    <WidgetWrapper
      smallWidgetExtended
      dataTestId="upcoming-daily-mission-widget"
      sizeType={sizeType}
      onClick={handleClick}
    >
      {sizeType === 'small' ? (
        <GeneralSmallWidget timer={timer} widgetImageUrl={crownPillowImg} />
      ) : (
        <GeneralWideWidget timer={timer} widgetImageUrl={crownPillowImg} />
      )}
    </WidgetWrapper>
  );
}

export const UpcomingDailyMissionWidget = observer(UpcomingDailyMissionWidgetComponent);
